<template>
  <v-layout class="mb-3 grey lighten-3 pa-2" row align-center justify-space-between>

    <v-flex>
      <v-layout row align-center>
        <v-flex class="mr-1 header-icon" shrink>
          <slot name="icon"></slot>
        </v-flex>

        <v-flex shrink >
          <h1 class="subtle all-caps" :class="size">
            <!-- default slot -->
            <slot></slot>
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex>
      <v-layout row align-center justify-end>
        <slot name="buttons"></slot>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
export default {
  name: 'HeaderBar',
  props: ['size'],
}
</script>

<style scoped>
.header-icon .material-icons {
  font-size: 3.5em;
}
</style>
